import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Il Filo: proposta di sintesi di periodo SOLO se il backend rileva una vera ricorrenza
// nelle stese recenti (stessa carta 3+ volte in 30 giorni) e i cooldown lo consentono.
export const FiloOffer = ({ visible }) => {
  const [state, setState] = useState("idle"); // idle | ask | loading | text | closed
  const [text, setText] = useState("");

  useEffect(() => {
    if (!visible || state !== "idle") return;
    let alive = true;
    api.post("/filo/offer")
      .then((r) => { if (alive && r.data.offer) setState("ask"); })
      .catch(() => {});
    return () => { alive = false; };
  }, [visible, state]);

  const accept = async () => {
    setState("loading");
    try {
      const { data } = await api.post("/filo/sintesi");
      setText(data.text);
      setState("text");
    } catch {
      setState("closed");
    }
  };

  const decline = async () => {
    setState("closed");
    try { await api.post("/filo/declina"); } catch { /* non insistere mai */ }
  };

  if (state === "idle" || state === "closed") return null;

  return (
    <div className="mystic-card p-5 mt-6" data-testid="filo-offer">
      {state === "ask" && (
        <>
          <p className="text-sm text-purple-100/85 leading-relaxed">
            Noto che nelle ultime settimane tornano certi segnali.
            Vuoi una breve sintesi di quello che sta emergendo dalle tue stese?
          </p>
          <div className="flex gap-2 mt-4">
            <button onClick={accept} data-testid="filo-accept-btn"
              className="gold-btn px-5 py-2 text-xs tracking-wide">
              Sì, mostrami
            </button>
            <button onClick={decline} data-testid="filo-decline-btn"
              className="text-xs text-purple-300/60 hover:text-amber-300 transition-colors border border-[#4a2175] rounded-full px-5 py-2">
              No, grazie
            </button>
          </div>
        </>
      )}
      {state === "loading" && (
        <p className="text-sm text-purple-200/70 italic" data-testid="filo-loading">Rileggo le tue stese…</p>
      )}
      {state === "text" && (
        <>
          <p className="font-cinzel text-[11px] tracking-[0.25em] uppercase text-amber-400/80 mb-3">Il filo delle tue stese</p>
          <p className="text-sm text-purple-100/85 leading-relaxed whitespace-pre-wrap" data-testid="filo-text">{text}</p>
        </>
      )}
    </div>
  );
};
